import axiosInstance from "../../utils/axios";

// ใช้สำหรับหน้า รายการทั้งหมด
const getAllProductsPawn = async () => {
  try {
    const response = await axiosInstance.get("/manage/getAllProductsPawn");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

// ใช้สำหรับแสดงสิทธิ์ผู้ใช้งาน
const getPermission = async () => {
  try {
    const response = await axiosInstance.get("/manage/roles");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

// ใช้สำหรับแสดงบริษัท
const getAllCompany = async () => {
  try {
    const response = await axiosInstance.get("/manage/company");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

// ใช้สำหรับหน้ารายชื่อลูกคา้า

const getAllCustomers = async () => {
  try {
    const response = await axiosInstance.get("/manage/customers");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

// ใช้สำหรับหน้าร้าน/บริษัท

const getAllCompanies = async () => {
  try {
    const response = await axiosInstance.get("/manage/company");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

// ใช้สำหรับแสดงรายชื่อผู้ใช้งาน

const getUsers = async () => {
  try {
    const response = await axiosInstance.get("/manage/users");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};
// ใช้สำหรับการจัดการแพ็กเกจ
const getAllPackages = async () => {
  try {
    const response = await axiosInstance.get("/manage/getAllPackages");
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};
const createPackage = async (value) => {
  try {
    const response = await axiosInstance.post("/manage/package", value);
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};
const updatePackage = async (value) => {
  try {
    const response = await axiosInstance.patch("/manage/updatePackage", value);
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};
const deletePackage = async (id) => {
  try {
    const response = await axiosInstance.delete(`/manage/deletePackage/${id}`);
    return response.data;
  } catch (err) {
    console.error("Error fetching order:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};
// ใข้สำหรัยสร้างบริษัท
const createCompany = async (values) => {
  try {
    // Log all files
    values.getAll("file[]").forEach((file) => {
      // console.log("Creating customer with file:", file);
    });

    const response = await axiosInstance.post("/manage/company", values);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const updateCompany = async (id, values) => {
  try {
    const response = await axiosInstance.put(`/manage/company/${id}`, values);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const CompanySetting = async (id, values) => {
  try {
    const response = await axiosInstance.put(
      `/manage/company-setting/${id}`,
      values
    );
    return response.data;
  } catch (err) {
    throw err; // Propagate error to handle it in the calling function
  }
};

// ใช้สำหรับออกบิล
const getBill = async (values) => {
  try {
    const response = await axiosInstance.get("/manage/bill");
    return response.data;
  } catch (err) {
    throw err; // Propagate error to handle it in the calling function
  }
};

const getCompanyData = async (id) => {
  try {
    const response = await axiosInstance.get(`/manage/company/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getCompanyMarketPlace = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/manage/company/marketplace/${id}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const updateChangeStatusMarketPlaceCompany = async (values, id) => {
  try {
    const response = await axiosInstance.put(
      `/manage/company/update-status-marketplace/${id}`,
      values
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

// ใช้สำหรับการอนุมัติของหน้าร้าน/บริษัท
const approvedCompanyPackage = async (id, values) => {
  try {
    const response = await axiosInstance.patch(`/manage/company/${id}`, values);
    return response.data;
  } catch (err) {
    throw err;
  }
};

// ใช้สำหรับดึงข้อมูลของสัญญาการใช้งานหน้าร้าน/บริษัท
const getCompanyUsePackage = async (id) => {
  try {
    const response = await axiosInstance.get(`/manage/company/package/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const addDateCompanyPackage = async (id, values) => {
  try {
    const response = await axiosInstance.post(
      `/manage/company/add-date/${id}`,
      values
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getHistoryLog = async () => {
  try {
    const response = await axiosInstance.get(`/manage/historylog`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const createUser = async (values) => {
  try {
    const response = await axiosInstance.post(`/manage/user`, values);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const updateUser = async (id, value) => {
  try {
    const response = await axiosInstance.put(`/manage/user/${id}`, value);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const userApproved = async (id, values) => {
  try {
    const response = await axiosInstance.patch(`/manage/user/${id}`, {
      status: values,
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

const ChangePassword = async (id, values) => {
  try {
    const response = await axiosInstance.patch(
      `/manage/change-password/${id}`,
      values
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getAllOrder = async () => {
  try {
    const response = await axiosInstance.get(`/manage/orders`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

//dashboard
const getCompanyWillExpired = async () => {
  try {
    const response = await axiosInstance.get(
      `/manage/dashboard/company-expired`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getRevenueSummary = async () => {
  try {
    const response = await axiosInstance.get(`/manage/dashboard/revenue`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getReport = async () => {
  try {
    const response = await axiosInstance.get(`/manage/dashboard/report`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getBillDebt = async (company) => {
  try {
    const response = await axiosInstance.get(`/manage/bill-debt/${company}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
const createBill = async (values) => {
  try {
    const response = await axiosInstance.post(`/manage/bill-debt`, values);
    return response.data;
  } catch (error) {
    throw error;
  }
};
const getBillDebtPdf = async (bill_debt_id) => {
  try {
    const response = await axiosInstance.get(
      `/manage/pdf-bill/${bill_debt_id}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const deleteUser = async (user_id) => {
  try {
    const response = await axiosInstance.delete(`/manage/user/${user_id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const SuperAdminApi = {
  getAllProductsPawn,
  getAllCustomers,
  getPermission,
  getAllCompany,
  getAllCompanies,
  getUsers,
  createCompany,
  updateCompany,
  getAllPackages,
  createPackage,
  updatePackage,
  deletePackage,
  getBill,
  getCompanyData,
  getCompanyMarketPlace,
  approvedCompanyPackage,
  getHistoryLog,
  createUser,
  updateUser,
  getCompanyUsePackage,
  addDateCompanyPackage,
  getAllOrder,
  getReport,
  getCompanyWillExpired,
  getRevenueSummary,
  updateChangeStatusMarketPlaceCompany,
  getBillDebt,
  createBill,
  getBillDebtPdf,
  CompanySetting,
  userApproved,
  ChangePassword,
  deleteUser,
};

export default SuperAdminApi;
